import React from 'react';
import { useCardBarStore, CardBarConfig } from './useCardBarConfig';

/**
 * Hook for pages to configure the shared FormulaCardBar on mount.
 * Resets to defaults on unmount so each page gets a clean slate.
 *
 * Usage:
 *   useCardBar({ filterWatchOnly: true, onSelectPath: '/hedges' });
 *   useCardBar({ visible: false }); // admin pages
 */
export function useCardBar(config: Partial<CardBarConfig>) {
  const { setConfig, resetConfig } = useCardBarStore();

  // Update config when it changes
  React.useEffect(() => {
    setConfig(config);
  }, [JSON.stringify(config)]);

  // Reset to defaults only when page unmounts
  React.useEffect(() => {
    return () => resetConfig();
  }, []);
}
